<template>
  <div>
    <b-card-actions
      :show-loading="fetchingPermitLicenses"
      :title="`Vencimento do ${permitLicenseType.label}`"
      action-collapse
    >
        <b-row>
          <b-col>
            <b-table
              :ref="`permit-licenses-table-${permitLicenseType.value}`"
              show-empty
              responsive
              striped
              class="bordered"
              empty-text="Sem resultados"
              :fields="fields"
              :items="currentTypeData.permitLicenses"
              no-local-sorting
            >
              <template #cell(tradingName)="row">
                <e-router-link
                  :title="$t('Loja')"
                  :to="{
                    name: 'company-maintain',
                    params: { id: row.item.companyId },
                  }"
                  :value="`${row.item.identification || row.item.companyId} - ${row.item.storeTradingName}`"
                />
              </template>
              <template #cell(dueDate)="row">
                <e-status-badge
                  :variant="row.item.color"
                  type="noOptions"
                  :status="row.item.elapsedTime"
                />
              </template>
              <template #cell(observation)="row">
                {{ row.item.observation }}
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <e-pagination-summary
              :current-page="getPagingByType(permitLicenseType.value).currentPage"
              :per-page="getPagingByType(permitLicenseType.value).pageSize"
              :total="getPagingByType(permitLicenseType.value).rowCount"
              :total-on-page="getPagingByType(permitLicenseType.value).rowsInCurrentPage"
            />
          </b-col>
          <b-col>
            <b-pagination
              :value="getPagingByType(permitLicenseType.value).currentPage"
              align="right"
              :total-rows="getPagingByType(permitLicenseType.value).rowCount"
              :per-page="getPagingByType(permitLicenseType.value).pageSize"
              :aria-controls="`permit-licenses-table-${permitLicenseType.value}`"
              @change="page => onPageChangeByType(permitLicenseType.value, page)"
            />
          </b-col>
        </b-row>
      </b-card-actions>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { BTable, BPagination, BRow, BCol } from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { companyDomains } from '@/mixins'
import ERouterLink from '../ERouterLink.vue'
import EStatusBadge from '../EStatusBadge.vue'
import EPaginationSummary from '../pagination/EPaginationSummary.vue'

export default {
  components: {
    BCardActions,
    ERouterLink,
    EStatusBadge,
    BTable,
    EPaginationSummary,
    BPagination,
    BRow,
    BCol,
  },
  mixins: [companyDomains],
  props: {
    permitLicenseType: {
      value: String,
      label: String,
    },
  },
  data() {
    return {
      fetchingPermitLicenses: false,
    }
  },
  computed: {
    ...mapState('pages/dashboard/permitLicenses', [
      'pagingByType',
      'currentPermitLicenses'
    ]),

    currentTypeData() {
      return this.currentPermitLicenses.find(item => item.type === this.permitLicenseType.value) || {
        type: this.permitLicenseType.value,
        permitLicenses: [],
        totalCount: 0,
        expiredCount: 0
      }
    },

    fields() {
      const fields = [
        {
          label: this.$t('Loja'),
          key: 'tradingName',
          thClass: 'text-center',
          tdClass: 'text-left',
          sortable: false,
        },
        {
          label: this.$t('Vencimento'),
          key: 'dueDate',
          class: 'text-center',
          thStyle: { width: '150px' },
          sortable: false,
        },
      ]

      if (this.showObservation) {
        fields.push({
          label: this.$t('Observação'),
          key: 'observation',
          class: 'text-center',
          tdClass: 'text-left',
          sortable: false,
        })
      }

      return fields
    },

    showObservation() {
      return this.permitLicenseType.value === 'PropertyTax'
    },
  },
  async mounted() {
    await this.loadPermitLicenses()
  },
  methods: {
    ...mapActions('pages/dashboard/permitLicenses', [
      'pageChangeByType',
      'fetchCurrentPermitLicensesByType',
    ]),
    getPagingByType(type) {
      return this.pagingByType[type] || {
        currentPage: 1,
        pageCount: 1,
        pageSize: 10,
        rowCount: 0,
        rowsInCurrentPage: 0
      }
    },
    async loadPermitLicenses() {
      try {
        this.fetchingPermitLicenses = true
        await this.fetchCurrentPermitLicensesByType({ type: this.permitLicenseType.value })
      } catch (error) {
        this.showError({ error })
      } finally {
        this.fetchingPermitLicenses = false
      }
    },
    async onPageChangeByType(type, page) {
      try {
        this.fetchingPermitLicenses = true
        await this.pageChangeByType({ type, page })
      } catch (error) {
        this.showError({ error })
      } finally {
        this.fetchingPermitLicenses = false
      }
    },
  }
}
</script>
